import { SessionState } from 'state/session-store';

export const isGdsSessionsEnabled = (session: SessionState): boolean => {
  const { tenant } = session;

  if (!tenant) return false;

  return tenant.capabilities.gds_sessions === true;
};
